export enum PaymentMethodTypeEnum {
  creditCard = 1,
  googlePay = 2,
  applePay = 3,
  link = 4,
}

export enum PaymentTypeIdEnum {
  stripeCreditCard = 1,
  payPal = 2,
  check = 3,
  payPalCreditCard = 4,
  razorPay = 5,
  stripeLink = 6,
}

export type PaymentMethodType = {
  CardBrand: string;
  CardLast4: string;
  CardExpDate: string;
  StripeLinkEmail: string;

  // there might be either of two
  CreditCardPaymentMethodTypeID?: PaymentMethodTypeEnum;
  UserStripePaymentMethodID?: PaymentMethodTypeEnum;

  // there might be either of two
  PaymentTypeID?: PaymentTypeIdEnum;
  PaymentMethodTypeId?: number; // ValueOf<typeof Enums.StripePaymentMethodType>;

  SelectedPaymentMethodTypeID?: number; // @see Enums.campaigns.PaymentTypeCode
  AdditionalInfo?: string;

  IsExpired?: boolean;
};
